import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flush", "scrollable", "title", "titleSize", "titleTagName", "toolbar"];
import { toShorthandSize } from '../../utils/tShirtSizes';
import { Text } from '../../../components/Text/Text';
import { Flex } from '../../../components/Flex/Flex';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import styled from 'foundations-theming/utils';
import { AccordionItem } from '../AccordionItem/AccordionItem';
import { sizeToHeading } from '../AccordionItem/AccordionItem.helpers';
import { useCardContext } from './CardContext';
import { StyledCardSection } from './CardSection';
import { AccordionTransitionWrapper } from '../AccordionTransition/AccordionTransition';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Toolbar = styled.div.withConfig({
  displayName: "CardHeader__Toolbar",
  componentId: "sc-1krr5i1-0"
})(({
  theme
}) => {
  return {
    flex: '1 0 auto',
    textAlign: 'right',
    marginLeft: theme.space['300']
  };
});
export const StyledHeader = styled.div.withConfig({
  displayName: "CardHeader__StyledHeader",
  componentId: "sc-1krr5i1-1"
})(({
  $flush,
  $compact,
  $cssStyles,
  theme
}) => {
  const spacing = $compact ? theme.space['600'] : theme.space['1000'];
  const paddingX = $flush ? theme.space['0'] : spacing;
  const padding = `${spacing} ${paddingX} ${spacing}`;
  return Object.assign({
    padding,
    borderRadius: 'inherit',
    // applies when CardWrapper expandable:false (CardSection renders children directly)
    [`& + ${StyledCardSection}`]: {
      paddingTop: theme.space['0']
    },
    // applies when CardWrapper expandable:true (CardSection renders children inside AccordionTransitionWrapper)
    [`& + ${AccordionTransitionWrapper} > ${StyledCardSection}`]: {
      paddingTop: theme.space['0']
    }
  }, $cssStyles);
});
export const CardHeader = _ref => {
  let {
      flush = false,
      scrollable = false,
      title,
      titleSize = 'md',
      titleTagName,
      toolbar
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const {
    compact,
    expandable,
    expanded,
    onOpen,
    onClose
  } = useCardContext();
  const shorthandSize = toShorthandSize(titleSize);
  const onCardToggle = open => {
    if (open) {
      onOpen();
    } else {
      onClose();
    }
  };
  return /*#__PURE__*/_jsx(StyledHeader, Object.assign({}, domProps, {
    $flush: flush,
    $scrollable: scrollable,
    $compact: compact,
    $cssStyles: cssStyles,
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "start",
      justifyContent: "space-between",
      children: [expandable ? /*#__PURE__*/_jsx(AccordionItem, {
        flush: true,
        isCardHeader: true,
        onOpenChange: onCardToggle,
        open: expanded,
        title: title,
        size: shorthandSize,
        titleTagName: titleTagName
      }) : /*#__PURE__*/_jsx(Text, {
        as: titleTagName || sizeToHeading[shorthandSize],
        children: title
      }), toolbar && expanded ? /*#__PURE__*/_jsx(Toolbar, {
        children: toolbar
      }) : null]
    })
  }));
};